export interface JobRoleTypes {
  lightWeightDriver: string;
  heavyWeightDriver: string;
}

export const JOB_ROLE_TYPES: JobRoleTypes = {
  lightWeightDriver: 'Light Weight Driver',
  heavyWeightDriver: 'Heavy Weight Driver'
};
